module.exports = "/_next/static/images/DeliverPersonalization@2x-b4c3a59abcc33c2b020f841a49a97d49.png";